import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrivateOfficeBlockComponent } from './private-office-block.component';

@NgModule({
  declarations: [PrivateOfficeBlockComponent],
  imports: [CommonModule],
  exports: [PrivateOfficeBlockComponent],
})
export class PrivateOfficeBlockModule {}
